import React, {useState, useEffect} from 'react';
import './App.css';
import generator from "./regex/generator";

function App() {
  const [counter, setCounter] = useState(10);
  const [exp, setExp] = useState('');
  const [output, setOutput] = useState([]);
  const [isValid, setIsValid] = useState(true);
  const handleCounter = (event) => {
    setCounter(event.target.value);
  }
  const handleExp = (event) => {
    setExp(event.target.value);
  }

  useEffect(() => {
    if(exp.length >= 2 && exp[0] === exp[exp.length - 1] && exp[0] === '/') {
      const regexString = exp.slice(1, exp.length - 1);
      if(regexString) {
        try {
          const regexExp = new RegExp(regexString);
          const list = generator(regexExp, counter);
          setOutput(list ? list : []);
          setIsValid(true);
        } catch(e) {
          setOutput([]);
          setIsValid(false);
          console.log("Not Valid");
        }
      } else {
        setOutput([]);
        setIsValid(true);
      }
    } else {
      setOutput([]);
    }
  }, [counter, exp]);


  return (
    <div className="App">
      <div className="Input">
        <input id="text" placeholder="/[0-9]{1,16}/" style={{ backgroundColor : isValid ? 'transparent' : 'red'}} value={exp} onChange={handleExp} /> 
        <input type="number" min="1" max="100" id="counter" value={counter} onChange={handleCounter} />
      </div>
      <div className="Show">
        {output.map((item, i) => (
          <div key={i} className="Item">
            {item}
          </div>
        ))}
        {output.length === 0 &&
        <div style={{textAlign: 'center', color: 'white'}}> Type a valid regex in above text field - generated strings will appear here :) </div>
        }
      </div>
      <footer className="Footer">
        <div className="Start"> Made With</div>
        <div className="Love"> ❤️ </div>
      </footer>
    </div>
  );
}

export default App;
